import { t } from "i18next";
import { Chip } from "@material-tailwind/react";
import { statusColors } from "../../../theme/statusPalette";

interface ReplenishmentStatusBadgeProps {
  status: EasyTech.ReplenishmentStatus;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const getReplenishmentStatusStyle = (status?: string | null) => {
  switch (status?.toUpperCase()) {
    case "CREATED":
      return {
        soft: statusColors["brilliant-rose"][100],
        mid: statusColors["brilliant-rose"][400],
        solid: statusColors["brilliant-rose"][500],
        text: statusColors["brilliant-rose"][800],
      };
    case "SENT":
      return {
        soft: statusColors["blue-chronoflex"][100],
        mid: statusColors["blue-chronoflex"][400],
        solid: statusColors["blue-chronoflex"][500],
        text: statusColors["blue-chronoflex"][800],
      };
    case "INVENTORIED":
      return {
        soft: statusColors["pastel-green"][100],
        mid: statusColors["pastel-green"][400],
        solid: statusColors["pastel-green"][500],
        text: statusColors["pastel-green"][800],
      };
    case "CANCELLED":
      return {
        soft: statusColors["purple-heart"][100],
        mid: statusColors["purple-heart"][400],
        solid: statusColors["purple-heart"][500],
        text: statusColors["purple-heart"][800],
      };
    default:
      return {
        soft: statusColors["chrono-gray"][100],
        mid: statusColors["chrono-gray"][400],
        solid: statusColors["chrono-gray"][500],
        text: statusColors["chrono-gray"][800],
      };
  }
};

/**
 * Badge coloré pour afficher le statut d'une demande de pièces
 * @param status - Statut de la demande
 * @param size - Taille du badge
 * @param className - Classes CSS additionnelles
 */
export default function ReplenishmentStatusBadge({ 
  status,
  size = "sm",
  className = "" 
}: ReplenishmentStatusBadgeProps) {
  const style = getReplenishmentStatusStyle(status);

  return (
    <Chip
      variant="ghost"
      size={size}
      value={t(`replenishment:status.${status}`)}
      className={`w-fit h-fit rounded-full capitalize text-xs py-1 ${className}`}
      style={{ backgroundColor: style.soft, color: style.text }}
    />
  );
}
